var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_apple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-298, -194)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(305, 198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.956933,2.4137931 C11.0636216,3.48664708 10.6199519,5.05561259 10.6259242,7.12068966 C12.6718711,6.79982631 14.1642144,6.07568838 15.102954,4.94827586 C16.0416936,3.82086335 16.5256968,2.17143806 16.5549637,0 C14.3829214,0.53634143 12.8502445,1.34093913 11.956933,2.4137931 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1529944,10.9827586 C19.7495069,9.60333673 18.5798324,8.79873903 17.643971,8.56896552 C16.7081095,8.33919201 15.2560998,8.50011155 13.2879419,9.05172414 C12.7501605,9.37356322 12.1854901,9.53448276 11.5939306,9.53448276 C11.0023711,9.53448276 10.1150319,9.37356322 8.93191285,9.05172414 C6.99589994,8.32758621 5.26155504,8.40804598 3.72887816,9.29310345 C1.42986282,10.6206897 0.461856369,11.8275862 0.0988539488,14.7241379 C-0.264148472,17.6206897 0.425230458,19.4374076 1.30886202,21.9655172 C2.19249358,24.4936269 3.47935343,25.7733819 4.21288138,26.5517241 C4.94640934,27.3300664 6.1892279,28 6.99589994,28 C7.80257199,28 8.68991124,27.3965517 9.41591608,27.1551724 C10.1419209,26.9137931 10.5049233,26.6724138 11.5939306,26.6724138 C12.3199354,26.6724138 12.9652731,26.8333333 13.5299435,27.1551724 C14.6592844,27.7183908 15.5466236,28 16.1919613,28 C17.1599677,28 18.1279742,26.9137931 19.4589831,25.4655172 C20.3463223,24.5 21.193328,23.091954 22,21.2413793 C19.6606511,20.0344828 18.450643,18.3850575 18.3699758,16.2931034 C18.2893086,14.2011494 19.2169814,12.4310345 21.1529944,10.9827586 Z",
    id: "\\u8DEF\\u5F84-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon_apple.b9ce19ecc007bd498c5bc3ac62c6abb7.svg";
export { ForwardRef as ReactComponent };